import axios from 'axios'

//let base = 'http://localhost:8087/pine2'
let base = 'http://193.112.181.218:8083/pine'

if (process.env.NODE_ENV === 'development') {
  // 开发环境：用相对路径，走 proxyTable 代理
  base = '/'  // 注意：这里不要写完整 URL
} else {
  // 生产环境（打包后）：直接写后端真实地址
  base = 'http://193.112.181.218:8083/pine'  
}

// 创建 axios 实例
const service = axios.create({
  baseURL: base,
  timeout: 10000
}) 


//获取用户报告列表
export const getUtrList = params => {
  return axios.get(`pine/user/v1/utr`, { params: params })
}

//根据标记名搜索

/**
 * 
 * 登录页面
 * 
 */

 //用户登录
 export const userLogin = params => {
  return axios.post(`pine/app/user/v1/login`, params)
}

/**
 * 
 * 菜单栏
 * 
 */

 //获取用户菜单(五级联动 省级)
 export const disListPro = params => {
  return axios.get(`pine/user/v1/selectpro`,  { params: params })
}
 //获取用户菜单(五级联动 市级)
 export const disListCity = params => {
  return axios.get(`pine/user/v1/selectcity`,  { params: params })
}
 //获取用户菜单(五级联动 区级)
 export const disListOu = params => {
  return axios.get(`pine/user/v1/selectcou`,  { params: params })
}
 //获取用户菜单(五级联动 town级)
 export const disListTown = params => {
  return axios.get(`pine/user/v1/selecttown`,  { params: params })
}
 //获取用户菜单(五级联动 record级)
 export const disListRecord = params => {
  return axios.get(`pine/user/v1/selectrec`,  { params: params })
}
 //获取用户菜单(两级菜单)
 export const disList = params => {
  return axios.get(`pine/app/user/v1/selectmenu`,  { params: params })
}

//
//查询标记列表
export const searchMarkInfo = params => {
  return axios.get(`pine/marker/v1/sml`, { params: params })
}
//查询标记图片
export const searchMarkPic = params => {
  return axios.get(`pine/marker/v1/smi`, { params: params })
}
//获取验证码
export const getCode = params => {
  return axios.get(`pine/app/user/v1/code`, { params: params })
}

//更新用户位置
export const getCo = params => {
  return axios.post(`pine/app/track/v2/insertTrack`, params)
}

//上传文件
export const uploadFile = params => {
  return axios.post(`pine/file/v1/upload`, params)
}

//上传图片
export const uploadImg = params => {
  return axios.post(`pine/app/track/v3/insertphoto`, params)
}

//查询地图token
export const getMapToken = params => {
  return axios.get(`pine/user/v3/selecttoken`, { params: params })
}
//查询百度地图
export const getCoord = params => {
  return axios.get('http://api.map.baidu.com/geocoder', { params: params })
}


// WEBPACK FOOTER //
// ./src/api/api.js